import {Deserializable} from "./deserializable.model";

export class SubjectsUrgentExportJobShedule {

    // :; A service rule is assocuated with document types.

// job_service_rule_id: number;

// timeframe_surcharge_id: number;
// timeframe_surcharge_name: string;
// timeframe_surcharge_description: string;
// timeframe_from: string;
// timeframe_to: string;
// time_frame_type: string;
// timeframe_duration_ms: number;
// is_active: any;
// colour: string;
// icon: string;

// surcharge_percentage: number;

id?: number;
  name?: string;
  frequency?: string;
  last_run?: string;
  email?: string;
  brand_id?: number;
  is_active?: string;
  job_type_id?: number;
  job_status?: string;
  brand_report_id?: number;
  timeframe_surcharge_id
  created_date_from?: string;
  created_date_to?: string;
  final_date_from?: string;
  final_date_to?: string;
  hearing_date_from?: string;
hearing_date_to?: string;
  next_date_from?: string;
  next_date_to?: string;
  created_by?: number;
description?: string;
colour: string;
icon: string;

  suot_id?: number;
  send_to_recipient?: string;
  send_to_selected_brand_report_email?: string;
  send_to_selected_brand_report_user_id?: string;
  send_to_chosen_brand_recipient?: string;
  send_to_selected_brand_invoice_email?: string;
  brand_report_user_id?: number;
chosen_brand_recipient_id?: number;

/*
id
  name
  frequency
  last_run
  email
  brand_id
  is_active
  job_type_id
  job_status
  brand_report_id
  timeframe_surcharge_id
  created_date_from
  created_date_to
  final_date_from
  final_date_to
  hearing_date_from
hearing_date_to
  next_date_from
  next_date_to
  created_by,
  description,
  colour,
  icon

  suot_id
  send_to_recipient
  send_to_selected_brand_report_email
  send_to_selected_brand_report_user_id
  send_to_chosen_brand_recipient
  send_to_selected_brand_invoice_email
  brand_report_user_id

*/



  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SubjectsUrgentExportJobShedule {
    Object.assign(this, input);

    return this;
  }


}
